export enum LoadingSpinnerSize {
    large = "large",
    medium = "medium",
    small = "small",
}
